import { RBTechnical } from 'store/railsBuilder/reducer.types';
import { Entitlement } from 'store/user/reducer.types';

import { TECHNICAL_DEVICE_TYPE } from 'services/data-manager/constants';

export default function getVodDetailsExpiryDate(
    technicals: RBTechnical[],
    entitlements: Entitlement[],
) {
    const technical = technicals?.find(({ deviceType }) =>
        deviceType?.includes(TECHNICAL_DEVICE_TYPE),
    );

    const rentedEntitlement = entitlements.find(
        (entitlement) => entitlement.productId === technical?.products?.[0].id,
    );

    return rentedEntitlement?.expiryDate;
}
